<template>
  <p
    v-if="showSuccess"
    class="pb-5 lg:pb-16"
  >
    {{ $t('Thanks') }}
  </p>
  <div v-else>
    <FormKit
      id="contact-form"
      v-model="formData"
      type="form"
      :actions="false"
      @submit="sendContact"
    >
      <FormKit
        name="question"
        type="textarea"
        validation="required"
        :label="$t('How can we help you?')"
        :validation-label="$t('Question')"
        label-class="!text-black"
      />
      <FormKit
        name="company"
        type="text"
        placeholder="*"
        validation="required"
        :label="$t('Company name')"
        label-class="!text-black"
      />
      <FormKit
        name="name"
        type="text"
        placeholder="*"
        validation="required"
        :label="$t('Name')"
        label-class="!text-black"
      />
      <FormKit
        name="email"
        placeholder="*"
        type="email"
        validation="required|email"
        :label="$t('Email address')"
        label-class="!text-black"
      />
      <FormKit
        name="phone"
        type="tel"
        placeholder="*"
        validation="required|matches:/[0-9]/|length:9,10"
        :label="$t('Phone number')"
        label-class="!text-black"
      />
      <FormKit
        type="submit"
        :label="$t('Submit')"
        :short-label="$t('Submit short')"
        @click="sendContact"
      />
    </Formkit>
  </div>
</template>

<script setup lang="ts">
import contactForm from '~/graphql/mutations/contact/contactForm.gql';

const formData = ref<Record<string, unknown>>({});
const showSuccess = ref(false);

const sendContact = async (formData: Record<string, unknown>) => {
  const {mutate} = useMutation(contactForm, {
    variables: {
      ...formData,
    },
  });

  await mutate();
  showSuccess.value = true;
  formData.value = false;
  window.scrollTo({top: 0, behavior: 'smooth'});
};
</script>
